import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-41d49c10"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "task-management-warp"
};
const _hoisted_2 = {
  class: "cms-card-block"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  class: "output-info-warp"
};
const _hoisted_5 = {
  style: {
    "font-size": "16px",
    "font-weight": "bold",
    "padding": "12px",
    "border-radius": "3px 3px 0 0",
    "background": "#eef8ff",
    "color": "#1D1F21"
  }
};
const _hoisted_6 = {
  style: {
    "padding": "25px",
    "border-radius": "0 0 3px 3px",
    "background-color": "#fff"
  }
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 0,
  style: {
    "width": "100%"
  }
};
const _hoisted_9 = {
  key: 1,
  style: {
    "width": "100%"
  }
};
const _hoisted_10 = {
  key: 2,
  style: {
    "width": "100%"
  }
};
const _hoisted_11 = {
  key: 1,
  class: "log-text-warp",
  style: {
    "max-height": "500px",
    "overflow": "auto"
  }
};
const _hoisted_12 = {
  key: 1,
  style: {
    "text-align": "center"
  }
};
import searchFilesSelect from '../components/searchFilesSelect.vue';
import ParamsFormGroup from '../components/ParamsFormGroup.vue';
import { getItemByProp, debounce, removePropertyOfNull, fileDownload } from '@/utils/tools';
import { usePageConfig } from '@/utils/useComponentConfig';
import { onMounted, reactive, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { elMessage } from '@/utils';
import { formValidator, messageBox } from '@/utils/validate';
import { getTaskListApi, getLanguageListApi, getServerListApi, getModeListApi, getFileListApi, addTaskApi, deleteTaskApi, getTaskLogApi, getFolderListApi, exportTaskListApi } from '@/api/mediaManagement';
import { getSysDictListApi } from '@/api/live';
import dayjs from 'dayjs'; // 新增任务

export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props) {
    const {
      t
    } = useI18n();
    const tableRef = ref(null);
    const paramsFormGroupRef = ref();
    const formRef = ref();
    const serverList = ref([]);
    const transferProtocolObj = ref([]);
    const languageList = ref([]);
    const searchConfig = reactive({
      size: {
        sm: 24,
        md: 12,
        lg: 8,
        xl: 6,
        xs: {}
      },
      formList: [{
        label: '服务器类型',
        prop: 'serverType',
        widgetType: 'Select',
        list: [{
          label: 'S3',
          value: 'S3'
        }, {
          label: 'GS',
          value: 'GS'
        }],
        change: () => {
          getData();
        }
      }, {
        label: '影片名称',
        prop: 'name',
        widgetType: 'input' // maxlength: 50

      }, {
        label: '转码状态',
        prop: 'status',
        widgetType: 'Select',
        list: [{
          label: t('全部'),
          value: ''
        }, {
          label: t('转码成功'),
          value: '1'
        }, {
          label: t('转码中'),
          value: '2'
        }, {
          label: t('转码失败'),
          value: '3'
        }],
        change: () => {
          getData();
        }
      }, {
        label: '转码ID',
        prop: 'jobId',
        widgetType: 'input'
      }, {
        label: '传输协议',
        prop: 'format',
        widgetType: 'Select',
        list: transferProtocolObj,
        valueKey: 'label',
        visibleChange: async isVisible => {
          let nowItem = getItemByProp(searchConfig.formList, 'format');

          if (isVisible && transferProtocolObj.value.length <= 1) {
            nowItem.loading = true;
            await getSysDictList('transfer_protocol');
            nowItem.loading = false;
          }
        },
        change: val => {
          getData();
        }
      }, {
        label: '影片源路径',
        prop: 'sourcePath',
        widgetType: 'input'
      }],
      formData: {
        name: undefined,
        status: '',
        serverType: 'GS',
        format: ''
      },
      handleSearch: () => {
        tableRef.value && tableRef.value.commonTableRef.clearSelection();
        getData();
      },
      handleReset: () => {
        tableConfig.paginationConfig.page = 1;
        searchConfig.formData.serverType = 'GS';
        tableRef.value && tableRef.value.commonTableRef.clearSelection();
        getData();
      }
    });
    const tableConfig = reactive({
      data: [],
      paginationConfig: usePageConfig(),
      isShowHeader: true,
      isCardBlock: false,
      listName: '任务管理',
      columnList: [{
        label: '',
        prop: '',
        type: 'selection',
        'reserve-selection': true // selectable: (row, index) => {
        //     // console.log('selection', row);
        //     return row.status == 1;
        // }

      }, {
        label: '任务ID',
        prop: 'id',
        sortable: true,
        width: 100
      }, {
        label: '影片名称',
        prop: 'movieName',
        sortable: true,
        minWidth: 250
      }, {
        label: '影片源路径',
        prop: 'sourcePath',
        sortable: true,
        minWidth: 350
      }, {
        label: '输出路径',
        prop: 'outputPath',
        sortable: true,
        minWidth: 350
      }, {
        label: '输出信息',
        prop: 'outputInfoList',
        cellSlot: true,
        width: 130
      }, {
        label: '转码ID',
        prop: 'jobId',
        sortable: true,
        width: 170
      }, {
        label: '传输协议',
        prop: 'format',
        sortable: true,
        width: 150
      }, {
        label: '转码设备',
        prop: 'transcodeDevice',
        sortable: true,
        width: 130,
        formatter: val => {
          return val == 'cpu' ? 'CPU' : val == 'gpu' ? 'GPU' : val == 'CPU' ? 'CPU' : val == 'GPU' ? 'GPU' : val ? val : '--';
        }
      }, {
        label: '下发时间',
        prop: 'createTime',
        sortable: true,
        width: 170
      }, {
        label: '转码状态',
        prop: 'status',
        width: 130,
        formatter: val => {
          // return val == 0 ? t('等待中') : val == 1 ? t('转码中') : val == 2 ? t('转码失败') : val == 3 ? t('转码成功') : '--';
          return val == 1 ? t('转码成功') : val == 2 ? t('转码中') : val == 3 ? t('转码失败') : '--';
        },
        sortable: true
      }, {
        label: '操作',
        prop: '',
        widgetType: 'buttons',
        fixed: 'right',
        width: 260,
        showOverflowTooltip: false,
        buttonsList: [{
          label: '查看',
          func: row => {
            actionForm.dialogConfig.title = '查看';
            actionForm.dialogConfig.isShowConfirm = false;
            actionForm.action = 'check';
            actionForm.visible = true;
            actionForm.formData = { ...row
            };
            actionForm.formData.file = row.sourcePath;
            paramsFormGroupData.value = row.outputInfoList;
          },
          controller: row => {
            return true;
          }
        }, {
          label: '编辑',
          func: row => {
            actionForm.dialogConfig.title = '编辑';
            actionForm.action = 'edit';
            actionForm.visible = true;
            actionForm.formData = { ...row
            }; // getTemplate('template2');
          },
          controller: row => {
            return false; // return true;
          }
        }, {
          label: '复制',
          func: row => {
            actionForm.dialogConfig.title = '复制';
            actionForm.dialogConfig.isShowConfirm = true;
            actionForm.action = 'copy';
            actionForm.visible = true;
            actionForm.formData = { ...row
            };
            actionForm.formData.file = row.sourcePath;
            paramsFormGroupData.value = row.outputInfoList;

            if (actionForm.formData.serverType) {
              getServerList(actionForm.formData.serverType);
            }
          }
        }, {
          label: '日志',
          func: row => {
            logText.value = '';
            actionForm.dialogConfig.title = '日志';
            actionForm.dialogConfig.isShowConfirm = false;
            actionForm.action = 'log';
            actionForm.visible = true;
            getTaskLog(row.id);
          },
          controller: row => {
            return true;
          }
        }, {
          label: '删除',
          func: row => {
            messageBox('确定删除这条数据吗?').then(async () => {
              tableConfig.options.loading = true;

              try {
                const res = await deleteTaskApi({
                  idList: [row.id]
                });

                if (res.code == '0') {
                  elMessage('success', '删除成功');
                  tableRef.value && tableRef.value.commonTableRef.clearSelection();
                  getData();
                } else {
                  tableConfig.options.loading = false;
                }
              } catch (error) {
                tableConfig.options.loading = false;
              }
            });
          }
        }]
      }],
      headerButtonsList: [{
        label: '删除',
        type: 'danger',
        func: () => {
          if (selectTableConfig.selectData.length === 0) {
            return elMessage('warning', '请先勾选需要删除的影片');
          } else {
            let ids = [];
            selectTableConfig.selectData.forEach(e => {
              ids.push(e.id);
            });
            messageBox('确定删除已选数据吗?').then(async () => {
              tableConfig.options.loading = true;

              try {
                const res = await deleteTaskApi({
                  idList: ids
                });

                if (res.code == '0') {
                  tableRef.value && tableRef.value.commonTableRef.clearSelection();
                  elMessage('success', '删除成功');
                  getData();
                } else {
                  tableConfig.options.loading = false;
                }
              } catch (error) {
                tableConfig.options.loading = false;
              }
            });
          }
        },
        controller: config => {
          config.disabled = !selectTableConfig.selectData.length ? true : false;
          return true;
        }
      }, {
        label: '新增',
        func: () => {
          // clearData(actionForm.formData);
          actionForm.formData = {
            serverType: 'S3',
            serverId: '',
            file: '',
            movieName: '',
            transcodeDevice: 'gpu',
            templateType: '0',
            format: 'HLS',
            segmentDuration: 10
          };
          actionForm.dialogConfig.title = '新增';
          actionForm.dialogConfig.isShowConfirm = true;
          actionForm.action = 'add';
          actionForm.visible = true;
        }
      }, {
        label: '导出',
        func: async () => {
          try {
            tableConfig.options.loading = true;
            let params = { ...searchConfig.formData,
              ...sortParams,
              taskFrom: 'manual'
            };
            const res = await exportTaskListApi(removePropertyOfNull(params));
            let fileName = `${'manual_task_list'}_${dayjs().format('YYYY-MM-DD')}.xls`;
            fileDownload(res, fileName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
          } catch (error) {} finally {
            tableConfig.options.loading = false;
          }
        }
      }],
      options: {
        loading: false
      },
      'row-key': row => {
        return row.id;
      }
    }); // 输出参数模板配置

    const paramsFormGroupData = ref([]);
    const actionForm = reactive({
      visible: false,
      loading: false,
      action: 'add',
      formList: [[{
        label: '服务器类型',
        prop: 'serverType',
        widgetType: 'Select',
        required: true,
        list: [{
          label: 'S3',
          value: 'S3'
        }, {
          label: 'GS',
          value: 'GS'
        }],
        controller: (value, data, config) => {
          if (actionForm.action == 'check') {
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.required = true;
            config.widgetType = 'Select';
          }

          return true;
        },
        change: val => {
          actionForm.formData.serverId = '';
          getServerList(val);
        }
      }], [{
        label: '存储名称',
        prop: 'serverId',
        widgetType: 'Select',
        required: true,
        valueKey: 'id',
        labelKey: 'serverName',
        list: [],
        controller: (value, data, config) => {
          if (actionForm.action == 'check') {
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.required = true;
            config.widgetType = 'Select';
          }

          return true;
        },
        change: val => {
          actionForm.formData.file = '';
          actionForm.formData.movieName = '';
        }
      }], [{
        label: '选择文件',
        prop: 'file',
        required: true,
        itemSlot: true,
        controller: (value, data, config) => {
          if (actionForm.action == 'check') {
            config.itemSlot = false;
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.itemSlot = true;
            config.required = true;
          }

          return true;
        }
      }], [{
        label: '输出路径',
        prop: 'outputPath',
        required: true,
        itemSlot: true,
        controller: (value, data, config) => {
          if (actionForm.action == 'check') {
            config.itemSlot = false;
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.itemSlot = true;
            config.required = true;
          }

          return true;
        }
      }], [{
        label: '影片名称',
        prop: 'movieName',
        widgetType: 'input',
        required: true,
        disabled: true,
        controller: (value, data, config) => {
          if (actionForm.action == 'check') {
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.required = true;
            config.widgetType = 'input';
          }

          return true;
        }
      }], [{
        label: '转码设备',
        prop: 'transcodeDevice',
        widgetType: 'Select',
        required: true,
        list: [{
          label: 'cpu',
          value: 'cpu'
        }, {
          label: 'gpu',
          value: 'gpu'
        }],
        controller: (value, data, config) => {
          if (actionForm.action == 'check') {
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.required = true;
            config.widgetType = 'Select';
          }

          return true;
        },
        formatter: val => {
          if (actionForm.action == 'check') {
            return val == 'cpu' ? 'CPU' : val == 'gpu' ? 'GPU' : val == 'CPU' ? 'CPU' : val == 'GPU' ? 'GPU' : val ? val : '--';
          } else {
            return val;
          }
        }
      }], [{
        label: '转码模板',
        prop: 'templateType',
        widgetType: 'Select',
        required: true,
        list: [],
        change: val => {
          if (val != '0') {
            getTemplate(val);
          }
        },
        formatter: val => {
          if (actionForm.action == 'check') {
            if (actionForm.formData.templateType == '0') {
              return t('手动配置');
            } else if (actionForm.formData.templateType == '1') {
              // console.log(1111111, actionForm.formData, val)
              let itemList = getItemByProp(actionForm.formList, 'templateType').list;
              let findItem = itemList.find(f => f.id == actionForm.formData.templateId);
              return findItem ? findItem.label : '--';
            }
          } else {
            return val;
          }
        },
        controller: (value, data, config) => {
          if (actionForm.action == 'check') {
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.required = true;
            config.widgetType = 'Select';
          }

          return true;
        }
      }], [{
        label: '传输协议',
        prop: 'format',
        widgetType: 'Select',
        required: true,
        list: [{
          label: 'HLS',
          value: 'HLS'
        }, {
          label: 'DASH',
          value: 'DASH'
        }],
        controller: (value, data, config) => {
          if (actionForm.action == 'check') {
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.required = true;
            config.widgetType = 'Select';
          }

          return true;
        }
      }], [{
        label: '切片时长',
        prop: 'segmentDuration',
        widgetType: 'input',
        append: 'S',
        required: false,
        controller: (value, data, config) => {
          if (actionForm.action == 'check') {
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.required = false;
            config.widgetType = 'input';
          }

          return true;
        }
      }], [{
        label: '内嵌字幕',
        prop: 'embedSubtitle',
        widgetType: 'Select',
        required: false,
        list: languageList,
        labelKey: 'name',
        valueKey: 'code',
        clearable: true,
        controller: (value, data, config) => {
          if (actionForm.action == 'check') {
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.required = false;
            config.widgetType = 'Select';
          }

          return true;
        }
      }], [{
        label: '水印存储地址',
        prop: 'logoUrl',
        widgetType: 'input',
        required: false,
        placeholder: 'eg: s3://abc/china.jpg',
        maxlength: 255,
        controller: (value, data, config) => {
          if (actionForm.action == 'check') {
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.required = false;
            config.widgetType = 'input';
          }

          return true;
        }
      }], [{
        label: '水印位置',
        prop: 'logoPos',
        widgetType: 'input',
        required: false,
        placeholder: 'eg: 1200:50',
        maxlength: 255,
        controller: (value, data, config) => {
          if (actionForm.action == 'check') {
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.required = false;
            config.widgetType = 'input';
          }

          return true;
        }
      }], [{
        label: '水印宽高',
        prop: 'logoSize',
        widgetType: 'input',
        required: false,
        placeholder: 'eg: 60x60',
        maxlength: 255,
        controller: (value, data, config) => {
          if (actionForm.action == 'check') {
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.required = false;
            config.widgetType = 'input';
          }

          return true;
        }
      }], [{
        label: '年龄水印存储地址',
        prop: 'logoUrlAge',
        widgetType: 'input',
        required: false,
        placeholder: 'eg: s3://abc/china.jpg',
        maxlength: 255,
        controller: (value, data, config) => {
          if (actionForm.action == 'check') {
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.required = false;
            config.widgetType = 'input';
          }

          return true;
        }
      }], [{
        label: '年龄水印位置',
        prop: 'logoPosAge',
        widgetType: 'input',
        required: false,
        placeholder: 'eg: 1200:50',
        maxlength: 255,
        controller: (value, data, config) => {
          if (actionForm.action == 'check') {
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.required = false;
            config.widgetType = 'input';
          }

          return true;
        }
      }], [{
        label: '年龄水印宽高',
        prop: 'logoSizeAge',
        widgetType: 'input',
        required: false,
        placeholder: 'eg: 60x60',
        maxlength: 255,
        controller: (value, data, config) => {
          if (actionForm.action == 'check') {
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.required = false;
            config.widgetType = 'input';
          }

          return true;
        }
      }], [{
        label: '去水印位置',
        prop: 'delogoPos',
        widgetType: 'input',
        required: false,
        placeholder: 'eg: 1200:50',
        maxlength: 255,
        controller: (value, data, config) => {
          if (actionForm.action == 'check') {
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.required = false;
            config.widgetType = 'input';
          }

          return true;
        }
      }], [{
        label: '去水印宽高',
        prop: 'delogoSize',
        widgetType: 'input',
        required: false,
        placeholder: 'eg: 60x60',
        maxlength: 255,
        controller: (value, data, config) => {
          if (actionForm.action == 'check') {
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.required = false;
            config.widgetType = 'input';
          }

          return true;
        }
      }], [{
        label: '音频语言',
        prop: 'audioLanguage',
        widgetType: 'Select',
        required: false,
        list: languageList,
        labelKey: 'name',
        valueKey: 'code',
        clearable: true,
        controller: (value, data, config) => {
          if (actionForm.action == 'check') {
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.required = false;
            config.widgetType = 'Select';
          }

          return true;
        }
      }], [{
        label: '音频采样率',
        prop: 'audioSample',
        widgetType: 'input',
        required: false,
        placeholder: '',
        maxlength: 255,
        type: 'number',
        controller: (value, data, config) => {
          if (actionForm.action == 'check') {
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.required = false;
            config.widgetType = 'input';
            config.type = 'number';
          }

          return true;
        }
      }], [{
        label: '外部字幕路径',
        prop: 'externalSubtitle',
        required: false,
        itemSlot: true,
        controller: (value, data, config) => {
          if (actionForm.action == 'check') {
            config.itemSlot = false;
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.itemSlot = true;
            config.required = false;
          }

          return true;
        }
      }], [{
        label: '外部字幕后缀',
        prop: 'externalSubtitleSuffix',
        widgetType: 'input',
        required: false,
        placeholder: '',
        maxlength: 255,
        controller: (value, data, config) => {
          if (actionForm.action == 'check') {
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.required = false;
            config.widgetType = 'input';
          }

          return true;
        }
      }], [{
        label: '广告裁剪开始时间',
        prop: 'cropStartTime',
        widgetType: 'timePicker',
        required: false,
        valueFormat: 'HH:mm:ss',
        maxlength: 255,
        controller: (value, data, config) => {
          if (actionForm.action == 'check') {
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.required = false;
            config.widgetType = 'timePicker';
          }

          return true;
        }
      }], [{
        label: '广告裁剪结束时间',
        prop: 'cropEndTime',
        widgetType: 'timePicker',
        required: false,
        placeholder: '',
        maxlength: 255,
        valueFormat: 'HH:mm:ss',
        controller: (value, data, config) => {
          if (actionForm.action == 'check') {
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.required = false;
            config.widgetType = 'timePicker';
          }

          return true;
        }
      }]],
      formData: {
        serverType: 'S3',
        serverId: '',
        file: '',
        format: 'HLS',
        movieName: '',
        transcodeDevice: 'gpu',
        templateType: '0',
        segmentDuration: 10,
        embedSubtitle: '',
        logoUrlAge: '',
        logoPosAge: '',
        logoSizeAge: '',
        logoUrl: '',
        logoPos: '',
        logoSize: '',
        audioSample: '',
        audioLanguage: '',
        externalSubtitleSuffix: '',
        delogoPos: '',
        delogoSize: '',
        cropEndTime: '',
        cropStartTime: ''
      },
      dialogConfig: {
        title: '新增',
        destroyOnClose: true,
        isShowConfirm: true
      },
      rules: {
        serverType: [{
          required: true,
          message: t('请选择服务器名称'),
          trigger: 'change'
        }],
        serverId: [{
          required: true,
          message: t('请选择存储桶'),
          trigger: 'change'
        }],
        file: [{
          required: true,
          message: t('请选择文件'),
          trigger: 'change'
        }],
        movieName: [{
          required: true,
          message: t('请选择文件'),
          trigger: 'change'
        }],
        transcodeDevice: [{
          required: true,
          message: t('请选择转码设备'),
          trigger: 'change'
        }],
        templateType: [{
          required: true,
          message: t('请选择转码模板'),
          trigger: 'change'
        }],
        outputPath: [{
          required: true,
          message: t('请选择输出路径'),
          trigger: 'change'
        }]
      },
      confirm: done => {
        formValidator(formRef.value.mForm).then(() => {
          if (actionForm.action == 'add') {
            // done();
            addTask(done);
          } else if (actionForm.action == 'edit') {
            done();
          } else if (actionForm.action == 'copy') {
            addTask(done);
          }
        }, () => done()); // Promise.all([formRef.value.mForm.validate(),
        // paramsFormGroupRef.value.paramsFormGroupRef.validate()]).then(valid => {
        //     done();
        //     console.log('validPass!');
        // }).catch(err => {
        //     done();
        //     scrollIntoView();
        // })
      }
    });

    const addTask = async done => {
      try {
        let params = {
          outputInfoList: paramsFormGroupRef.value.formConfig.formData,
          movieName: actionForm.formData.movieName,
          serverId: actionForm.formData.serverId,
          serverType: actionForm.formData.serverType,
          sourcePath: actionForm.formData.file,
          templateType: actionForm.formData.templateType == '0' ? 0 : 1,
          transcodeDevice: actionForm.formData.transcodeDevice,
          format: actionForm.formData.format,
          outputPath: actionForm.formData.outputPath,
          segmentDuration: actionForm.formData.segmentDuration,
          embedSubtitle: actionForm.formData.embedSubtitle,
          logoUrlAge: actionForm.formData.logoUrlAge,
          logoPosAge: actionForm.formData.logoPosAge,
          logoSizeAge: actionForm.formData.logoSizeAge,
          logoUrl: actionForm.formData.logoUrl,
          logoPos: actionForm.formData.logoPos,
          logoSize: actionForm.formData.logoSize,
          audioLanguage: actionForm.formData.audioLanguage,
          audioSample: actionForm.formData.audioSample ? parseInt(actionForm.formData.audioSample) : undefined,
          externalSubtitle: actionForm.formData.externalSubtitle,
          externalSubtitleSuffix: actionForm.formData.externalSubtitleSuffix,
          delogoPos: actionForm.formData.delogoPos,
          delogoSize: actionForm.formData.delogoSize,
          cropStartTime: actionForm.formData.cropStartTime,
          cropEndTime: actionForm.formData.cropEndTime
        };

        if (actionForm.formData.templateType != '0') {
          params.templateId = actionForm.formData.templateType;
        }

        ; // console.log('params', params);

        const res = await addTaskApi(params);

        if (res.code == '0') {
          elMessage('success', '新增成功');
          done();
          actionForm.visible = false;
          getData();
        } else {
          done();
        }
      } catch (error) {
        done();
      }
    }; // 获取模板输出参数回显


    const getTemplate = templateId => {
      let itemList = getItemByProp(actionForm.formList, 'templateType').list;
      let findItem = itemList.find(f => f.id == templateId);
      paramsFormGroupData.value = findItem ? JSON.parse(findItem.outputParam) : [];
    };

    const setOptionsBtnColumnWidth = width => {
      const findItem = tableConfig.columnList.find(item => item.label == '操作');
      findItem ? findItem.width = width : '';
    }; // 获取语言列表


    const getLanguageList = async () => {
      try {
        const {
          code,
          data
        } = await getLanguageListApi();

        if (code == 0) {
          languageList.value = data ? data : [];
        }
      } catch (error) {}
    };

    const selectTableConfig = reactive({
      selectData: [] // table已勾选的数据列表

    }); // table复选框点击事件

    const handleSelectionChange = val => {
      selectTableConfig.selectData = val;
    }; // 选择文件组件回调函数


    const searchFilesSelectConfirm = nodeItem => {
      if (nodeItem) {
        if (nodeItem.data.type == 'dir') {
          actionForm.formData.movieName = splitFilePath(nodeItem, nodeItem.data.name);
        } else {
          actionForm.formData.movieName = nodeItem.data.name;
        }
      } else {
        actionForm.formData.file = '';
        actionForm.formData.movieName = '';
      }

      formRef.value && formRef.value.mForm.validateField('file');
    };

    const splitFilePath = (node, str) => {
      if (node.parent.parent) {
        if (node.parent.level == 1) {
          str = node.parent.data.name + '/' + str;
        } else {
          str = node.parent.data.name + str;
        }

        return splitFilePath(node.parent, str);
      } else {
        return str;
      }
    };

    const splitFilePathWithoutFirstPath = (node, str) => {
      if (node.parent.parent && node.parent.level > 1) {
        str = node.parent.data.name + str;
        return splitFilePathWithoutFirstPath(node.parent, str);
      } else {
        return str;
      }
    }; // 选择文件组件点击事件


    const showFileListDialog = fn => {
      // console.log(fn);
      formRef.value.mForm.validateField('serverId', valid => {
        if (valid) {
          fn();
        }

        ;
      });
    };

    const sortParams = reactive({
      sortType: undefined,
      sortField: undefined
    }); // 表格排序

    const handleSortChange = debounce(async params => {
      // console.log(params);
      if (params.order) {
        const sortType = params.order.replace('ending', '');
        sortParams.sortType = sortType;
        sortParams.sortField = params.prop;
        getData();
      } else {
        getData();
      }
    }, 200);

    const getData = async () => {
      try {
        tableConfig.options.loading = true;
        let params = {
          pageNo: tableConfig.paginationConfig.page,
          pageSize: tableConfig.paginationConfig.limit,
          taskFrom: 'manual',
          ...searchConfig.formData,
          ...sortParams,
          type: 1
        };
        const res = await getTaskListApi(params);

        if (res.code == '0') {
          tableConfig.data = res.data.records;
          tableConfig.paginationConfig.total = res.data.total;
          tableConfig.options.loading = false;
        } else {
          tableConfig.options.loading = false;
        }
      } catch (error) {
        tableConfig.options.loading = false;
      }
    }; // 获取编码协议列表


    const getSysDictList = async type => {
      try {
        const {
          code,
          data
        } = await getSysDictListApi(type);

        if (code === '0') {
          transferProtocolObj.value = data ? [...data].filter(item => item.value !== 4) : [];
        }
      } catch (error) {}
    };

    const getServerList = async serverType => {
      try {
        actionForm.loading ? '' : actionForm.loading = true;
        const res = await getServerListApi(serverType);

        if (res.code == '0') {
          actionForm.loading = false;
          let item = getItemByProp(actionForm.formList, 'serverId');
          item.list = res.data;
          serverList.value = res.data;
        } else {
          actionForm.loading = false;
        }
      } catch (error) {
        console.log(error);
        actionForm.loading = false;
      }
    };

    const getTemplateType = async () => {
      let item = getItemByProp(actionForm.formList, 'templateType');
      item.list = [{
        label: t('手动配置'),
        value: '0'
      }];

      try {
        actionForm.loading ? '' : actionForm.loading = true;
        const res = await getModeListApi();

        if (res.code == '0') {
          actionForm.loading = false;

          if (res.data && res.data.length) {
            item.list = [...item.list, ...res.data.map(m => {
              return { ...m,
                label: m.name,
                value: m.id
              };
            })];

            if (actionForm.action != 'check' && actionForm.action != 'edit' && actionForm.action != 'copy') {
              actionForm.formData.templateType = res.data && res.data.length ? res.data[0].id : '0';
              getTemplate(res.data[0].id);
            }
          } else {
            actionForm.formData.templateType = '0';
          }
        } else {
          actionForm.formData.templateType = '0';
          actionForm.loading = false;
        }
      } catch (error) {
        console.log(error);
        actionForm.formData.templateType = '0';
        actionForm.loading = false;
      }
    };

    let treeNodeId = ref(0);

    const loadNode = async (node, resolve) => {
      if (node.level === 0) {
        treeNodeId.value = treeNodeId.value + 1;
        let path = serverList.value.filter(item => item.id == actionForm.formData.serverId)[0]?.path;
        return resolve([{
          disabled: true,
          id: treeNodeId.value,
          name: path ? path : '/',
          path,
          type: 'dir'
        }]);
      }

      if (node.level >= 1) {
        let params = {
          serverId: actionForm.formData.serverId,
          path: node.data.path
        };
        const res = await getFileListApi(params);
        console.log('getFolderListApi', res);

        if (res.code == '0') {
          return resolve(res.data.map(item => {
            treeNodeId.value = treeNodeId.value + 1;
            return { ...item,
              id: treeNodeId.value,
              leaf: item.type == 'dir' ? false : true
            };
          }));
        } else {
          return resolve([]);
        }
      }
    }; // 加载输出路径的节点


    const loadOutputPathNode = async (node, resolve) => {
      if (node.level === 0) {
        treeNodeId.value = treeNodeId.value + 1;
        return resolve([{
          id: treeNodeId.value,
          name: '/',
          type: 'dir'
        }]);
      }

      if (node.level >= 1) {
        let path = '';

        if (node.level > 1) {
          path = splitOutputPath(node, node.data.name == '/' ? '' : node.data.name);
        }

        let pathStrFormate = path.split('');
        pathStrFormate.splice(0, 1);
        let params = {
          key: pathStrFormate.join(''),
          //area: 'eu-west-1',
          serverType: actionForm.formData.serverType,
          serverId: actionForm.formData.serverId
        };
        const res = await getFolderListApi(params);
        console.log('getFolderListApi', res);

        if (res.code == '0') {
          return resolve(res.data.map(item => {
            treeNodeId.value = treeNodeId.value + 1;
            return { ...item,
              id: treeNodeId.value
            };
          }));
        } else {
          return resolve([]);
        }
      }
    };

    const splitOutputPath = (node, str) => {
      if (node.parent.parent) {
        str = node.parent.data.name + str;
        return splitOutputPath(node.parent, str);
      } else {
        return str;
      }
    }; // 选择输出路径的回调函数


    const outputPathSelectConfirm = nodeItem => {
      console.log(nodeItem);

      if (nodeItem) {
        if (nodeItem.data.name == '/') {
          actionForm.formData.outputPath = '';
          return;
        }

        let path = splitOutputPath(nodeItem, nodeItem.data.name).split('');
        path.splice(0, 1);
        actionForm.formData.outputPath = path.join('');
      } else {
        actionForm.formData.outputPath = '';
      }
    };

    const externalSubtitleConfirm = nodeItem => {
      if (nodeItem) {// if (nodeItem.data.type == 'dir') {
        //     actionForm.formData.movieName = splitFilePath(nodeItem, nodeItem.data.name);
        // } else {
        //     actionForm.formData.externalSubtitle = nodeItem.data.name;
        // }
      } else {
        actionForm.formData.externalSubtitle = '';
      }

      formRef.value && formRef.value.mForm.validateField('externalSubtitle');
    };

    const logText = ref('');

    const getTaskLog = async taskId => {
      try {
        actionForm.loading = true;
        const res = await getTaskLogApi({
          taskId
        });

        if (res.code == '0') {
          logText.value = res.data;
          actionForm.loading = false;
        } else {
          logText.value = '';
          actionForm.loading = false;
        }
      } catch (error) {
        logText.value = '';
        actionForm.loading = false;
      }
    };

    watch(() => actionForm.visible, val => {
      if (val && actionForm.action != 'log' && actionForm.action != 'edit' && actionForm.action != 'copy') {
        getServerList('S3');
        getTemplateType();
      }
    });
    onMounted(async () => {
      getLanguageList();
      getData();
    });
    return (_ctx, _cache) => {
      const _component_search_form = _resolveComponent("search-form");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _component_el_popover = _resolveComponent("el-popover");

      const _component_FormItem = _resolveComponent("FormItem");

      const _component_FormTable = _resolveComponent("FormTable");

      const _component_el_input = _resolveComponent("el-input");

      const _component_m_dialog = _resolveComponent("m-dialog");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_search_form, {
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        size: searchConfig.size,
        onSearch: searchConfig.handleSearch,
        onReset: searchConfig.handleReset,
        gutter: 30
      }, null, 8, ["form-list", "form-data", "size", "onSearch", "onReset"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_common_table, {
        "option-column-list": tableConfig.columnList,
        dynamicOption: "",
        onSetOptionsBtnColumnWidth: setOptionsBtnColumnWidth,
        ref_key: "tableRef",
        ref: tableRef,
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        options: tableConfig.options,
        render: getData,
        onSelectionChange: handleSelectionChange,
        onSortChange: _unref(handleSortChange)
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": tableConfig.columnList
        }, {
          cellSlot: _withCtx(scope => [scope.column.property == 'outputInfoList' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_popover, {
            "popper-style": {
              padding: 0
            },
            "show-arrow": false,
            "popper-class": "self-popper",
            width: "auto",
            placement: "bottom",
            trigger: "hover"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("header", _hoisted_5, _toDisplayString(_ctx.$t('输出信息')), 1), _createElementVNode("div", _hoisted_6, [_createVNode(_component_common_table, {
              style: {
                "width": "100%"
              },
              tableConfig: {
                data: scope.row.outputInfoList,
                showPageBar: false,
                isShowHeader: false,
                isCardBlock: false
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_column, {
                "column-list": [{
                  label: '输出文件名',
                  prop: 'outputFileName',
                  width: 300
                }, {
                  label: '视频编码类型',
                  prop: 'codeType',
                  width: 100
                }, {
                  label: '视频码率',
                  prop: 'codeRate',
                  width: 100
                }, {
                  label: '视频分辨率',
                  prop: 'resolutionRatio',
                  width: 130
                }]
              })]),
              _: 2
            }, 1032, ["tableConfig"])])])]),
            reference: _withCtx(() => [_createElementVNode("span", {
              style: {
                "overflow": "hidden",
                "text-overflow": "ellipsis"
              },
              class: "link",
              onClick: _cache[0] || (_cache[0] = () => {})
            }, _toDisplayString(_ctx.$t('信息')), 1)]),
            _: 2
          }, 1024)])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["option-column-list", "table-config", "pagination-config", "options", "onSortChange"])]), _createVNode(_component_m_dialog, {
        autoLoading: "",
        modelValue: actionForm.visible,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => actionForm.visible = $event),
        "dialog-config": actionForm.dialogConfig,
        nativeConfig: {
          width: '40%',
          closeOnClickModal: false
        },
        onOnConfirm: actionForm.confirm
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", null, [actionForm.action != 'log' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_FormTable, {
          "form-data": actionForm.formData,
          rules: actionForm.rules,
          ref_key: "formRef",
          ref: formRef
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actionForm.formList, item => {
            return _openBlock(), _createBlock(_component_FormItem, {
              "form-item": item,
              "form-data": actionForm.formData
            }, {
              itemSlot: _withCtx(scope => [scope.prop == 'file' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(searchFilesSelect, {
                filePath: actionForm.formData.file,
                "onUpdate:filePath": _cache[1] || (_cache[1] = $event => actionForm.formData.file = $event),
                onLoadNode: loadNode,
                onOnConfirm: searchFilesSelectConfirm,
                "before-show-dialog-valid": "",
                onShowDialog: showFileListDialog
              }, null, 8, ["filePath"])])) : _createCommentVNode("", true), scope.prop == 'outputPath' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(searchFilesSelect, {
                "can-select-folder": "",
                "show-batch-switch": false,
                "before-show-dialog-valid": true,
                onShowDialog: showFileListDialog,
                onLoadNode: loadOutputPathNode,
                "file-path": actionForm.formData.outputPath,
                "onUpdate:file-path": _cache[2] || (_cache[2] = $event => actionForm.formData.outputPath = $event),
                onOnConfirm: outputPathSelectConfirm
              }, null, 8, ["file-path"])])) : _createCommentVNode("", true), scope.prop == 'externalSubtitle' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(searchFilesSelect, {
                "can-select-folder": "",
                "show-batch-switch": false,
                "before-show-dialog-valid": true,
                onShowDialog: showFileListDialog,
                onLoadNode: loadNode,
                clearable: "",
                "file-path": actionForm.formData.externalSubtitle,
                "onUpdate:file-path": _cache[3] || (_cache[3] = $event => actionForm.formData.externalSubtitle = $event),
                onOnConfirm: externalSubtitleConfirm
              }, null, 8, ["file-path"])])) : _createCommentVNode("", true)]),
              _: 2
            }, 1032, ["form-item", "form-data"]);
          }), 256))]),
          _: 1
        }, 8, ["form-data", "rules"]), _createElementVNode("div", null, [_createVNode(ParamsFormGroup, {
          ref_key: "paramsFormGroupRef",
          ref: paramsFormGroupRef,
          "form-max-height": 270,
          "form-data": actionForm.action == 'check' ? paramsFormGroupData.value : actionForm.action != 'check' && actionForm.action != 'edit' && actionForm.action != 'copy' && actionForm.formData.templateType == '0' ? [] : paramsFormGroupData.value,
          action: actionForm.action == 'check' ? 'check' : actionForm.formData.templateType == '0' || actionForm.action != 'check' && actionForm.action != 'edit' && actionForm.action != 'copy' && actionForm.action != 'add' ? 'edit' : 'check'
        }, null, 8, ["form-data", "action"])])])) : _createCommentVNode("", true), actionForm.action == 'log' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [!actionForm.loading && logText.value ? (_openBlock(), _createBlock(_component_el_input, {
          key: 0,
          readonly: "readonly",
          autosize: "",
          resize: "none",
          type: "textarea",
          modelValue: logText.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => logText.value = $event)
        }, null, 8, ["modelValue"])) : _createCommentVNode("", true), !actionForm.loading && !logText.value ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('暂无数据')), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])), [[_directive_loading, actionForm.loading]])]),
        _: 1
      }, 8, ["modelValue", "dialog-config", "onOnConfirm"])]);
    };
  }

});